/** @format */

import React from 'react';

interface TextAreaInputProps {
	id: string;
	name: string;
	label?: string;
	value: string;
	onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
	placeholder?: string;
	required?: boolean;
	error?: boolean;
	errorMessage?: string;
	className?: string;
	disabled?: boolean;
	rows?: number;
}

const TextAreaInput: React.FC<TextAreaInputProps> = ({
	id,
	name,
	label,
	value,
	onChange,
	placeholder = '',
	required = false,
	error = false,
	errorMessage = `Field is required, ${value}`,
	className = '',
	disabled = false,
	rows = 6,
}) => (
	<div className='mb-4'>
		<label
			htmlFor={id}
			className='textInputLabel'>
			{label} {required && <span className='textInputLabelRequired'>*</span>}
		</label>

		<div className={`textAreaInput ${error ? 'error' : 'focus'}`}>
			<textarea
				id={id}
				name={name}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				disabled={disabled}
				rows={rows}
				className={`textArea ${className}`}
			/>
		</div>

		{error && <p className='textInputErrorMessage'>{errorMessage}</p>}
	</div>
);

export default TextAreaInput;
